import(/* webpackMode: "eager" */ "/app/app/[locale]/(withoutFooterOnMobile)/stories/layout.tsx");
